// Vận chuyển — tab đáy trên điện thoại (như tab "Vận chuyển" của app). Cùng nội dung với Cài đặt › Hãng vận chuyển,
// nhưng đứng riêng: không có "‹ Cài đặt", tiêu đề là "Vận chuyển". Kho lấy hàng mở từ link trong thẻ BEST.

import { useNavigate } from 'react-router-dom'
import { CarriersPanel } from '@/components/settings/CarriersPanel'

export default function ShippingPage() {
  const nav = useNavigate()
  return (
    <div className="max-w-5xl">
      <h1 className="mb-4">Vận chuyển</h1>
      <CarriersPanel onGoToWarehouse={() => nav('/settings?tab=warehouse')} />
    </div>
  )
}
